export const BREADCRUMBS_UPDATE_EVENT = 'dock.breadcrumbs.update';
export const DOCK_THEME_VARIANT = 'DOCK:theme-variant';
export const DOCK_USER_UPDATE_EVENT = 'DOCK:user-updated';
export const DOCK_USER_LOGOUT = 'DOCK:user-logout';
export const DOCK_NAVIGATOR_LINKS = 'DOCK:navigator-links';
export const DOCK_USER_LOCALE = 'Dock:User-Locale';

export { registerDockTopics } from './register';
